import React from "react";
import { Card } from "react-bootstrap";
import StarRating from "../StarRating";
const CustomerReviewDetails = ({ email, review, rating }) => {
  return (
    <Card className="my-3 d-flex flex-sm-column flex-md-row">
      <div className="pt-4 pl-3">
        <i className="fal fa-user-circle text-grey" style={{ fontSize: 82 }} />
      </div>
      <div>
        <Card.Body>
          {/* <Card.Text></Card.Text> */}
          <StarRating hover={true} rating={rating} />
          <Card.Title>{email}</Card.Title>
          <Card.Text> {review}</Card.Text>
        </Card.Body>
      </div>
    </Card>
  );
};
export default CustomerReviewDetails;
